// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adventure_wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 70px;
}

.adventure_heading {
  color: #fff;
  font-family: Inter;
  font-size: 70px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 10px;
}

.adventure_para {
  max-width: 1050px;
  color: #cecece;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Open Sans";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 38.4px; /* 160% */
}

.adventure_btn {
  color: #206d23;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-decoration-line: underline;
  background: none;
  border: none;
  margin-left: 5px;
  cursor: pointer;
}

.adventure_video_div {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}






@media screen and (max-width: 1200px) {

  .adventure_wrapper {
    margin-top: 50px;
  }
  
  .adventure_heading {
    font-size: 50px;
    margin-bottom: 10px;
  }
  
  .adventure_para {
    max-width: 100%;
    font-size: 24px;
    line-height: 30px;
    padding: 0 50px;
  }
  
  .adventure_btn {
    font-size: 24px;
    margin-left: 5px;
  }
  
  .adventure_video_div {
    margin-top: 20px;
  }
  

}












@media screen and (max-width: 1024px) {

  .adventure_wrapper {
    margin-top: 40px;
  }
  
  .adventure_heading {
    font-size: 40px;
    margin-bottom: 10px;
  }
  
  .adventure_para {
    max-width: 100%;
    font-size: 22px;
    line-height: 30px;
    padding: 0 50px;
  }
  
  .adventure_btn {
    font-size: 22px;
    margin-left: 5px;
  }
  
  .adventure_video_div {
    margin-top: 20px;
  }
  
}












@media screen and (max-width: 800px) {

  .adventure_wrapper {
    margin-top: 40px;
  }
  
  .adventure_heading {
    font-size: 40px;
    margin-bottom: 10px;
  }
  
  .adventure_para {
    max-width: 100%;
    font-size: 20px;
    line-height: 26px;
    padding: 0 30px;
  }
  
  .adventure_btn {
    font-size: 20px;
    margin-left: 5px;
  }
  
  .adventure_video_div {
    margin-top: 20px;
  }
  
}











@media screen and (max-width: 600px) {

  .adventure_wrapper {
    margin-top: 40px;
  }
  
  .adventure_heading {
    font-size: 36px;
    margin-bottom: 10px;
  }
  
  .adventure_para {
    max-width: 100%;
    font-size: 18px;
    line-height: 22px;
    padding: 0 20px;
  }
  
  .adventure_btn {
    font-size: 18px;
    margin-left: 5px;
  }
  
  .adventure_video_div {
    margin-top: 20px;
  }

  .adventure_video_div > video {
    width: 100%;
    object-fit: fill !important;
  }
  
}












@media screen and (max-width: 450px) {

  .adventure_wrapper {
    margin-top: 30px;
  }
  
  .adventure_heading {
    font-size: 30px;
    line-height: 34px;
    margin-bottom: 10px;
  }
  
  .adventure_para {
    max-width: 100%;
    font-size: 16px;
    line-height: 20px;
    padding: 0 20px;
  }
  
  .adventure_btn {
    font-size: 16px;
    margin-left: 5px;
  }
  
  .adventure_video_div {
    margin-top: 20px;
  }
    
}`, "",{"version":3,"sources":["webpack://./src/components/homePage/adventure/adventure.css"],"names":[],"mappings":"AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,6CAA6C;EAC7C,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAE,SAAS;AAChC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;;;;;;AAOA;;EAEE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;;AAGF;;;;;;;;;;;;;AAaA;;EAEE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;AAEF;;;;;;;;;;;;;AAaA;;EAEE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;AAEF;;;;;;;;;;;;AAYA;;EAEE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;;AAEF;;;;;;;;;;;;;AAaA;;EAEE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;AAEF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap\");\n\n.adventure_wrapper {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  margin-top: 70px;\n}\n\n.adventure_heading {\n  color: #fff;\n  font-family: Inter;\n  font-size: 70px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  margin-bottom: 10px;\n}\n\n.adventure_para {\n  max-width: 1050px;\n  color: #cecece;\n  font-feature-settings: \"clig\" off, \"liga\" off;\n  font-family: \"Open Sans\";\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 38.4px; /* 160% */\n}\n\n.adventure_btn {\n  color: #206d23;\n  font-family: Roboto;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  text-decoration-line: underline;\n  background: none;\n  border: none;\n  margin-left: 5px;\n  cursor: pointer;\n}\n\n.adventure_video_div {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n\n\n\n\n\n@media screen and (max-width: 1200px) {\n\n  .adventure_wrapper {\n    margin-top: 50px;\n  }\n  \n  .adventure_heading {\n    font-size: 50px;\n    margin-bottom: 10px;\n  }\n  \n  .adventure_para {\n    max-width: 100%;\n    font-size: 24px;\n    line-height: 30px;\n    padding: 0 50px;\n  }\n  \n  .adventure_btn {\n    font-size: 24px;\n    margin-left: 5px;\n  }\n  \n  .adventure_video_div {\n    margin-top: 20px;\n  }\n  \n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 1024px) {\n\n  .adventure_wrapper {\n    margin-top: 40px;\n  }\n  \n  .adventure_heading {\n    font-size: 40px;\n    margin-bottom: 10px;\n  }\n  \n  .adventure_para {\n    max-width: 100%;\n    font-size: 22px;\n    line-height: 30px;\n    padding: 0 50px;\n  }\n  \n  .adventure_btn {\n    font-size: 22px;\n    margin-left: 5px;\n  }\n  \n  .adventure_video_div {\n    margin-top: 20px;\n  }\n  \n}\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 800px) {\n\n  .adventure_wrapper {\n    margin-top: 40px;\n  }\n  \n  .adventure_heading {\n    font-size: 40px;\n    margin-bottom: 10px;\n  }\n  \n  .adventure_para {\n    max-width: 100%;\n    font-size: 20px;\n    line-height: 26px;\n    padding: 0 30px;\n  }\n  \n  .adventure_btn {\n    font-size: 20px;\n    margin-left: 5px;\n  }\n  \n  .adventure_video_div {\n    margin-top: 20px;\n  }\n  \n}\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 600px) {\n\n  .adventure_wrapper {\n    margin-top: 40px;\n  }\n  \n  .adventure_heading {\n    font-size: 36px;\n    margin-bottom: 10px;\n  }\n  \n  .adventure_para {\n    max-width: 100%;\n    font-size: 18px;\n    line-height: 22px;\n    padding: 0 20px;\n  }\n  \n  .adventure_btn {\n    font-size: 18px;\n    margin-left: 5px;\n  }\n  \n  .adventure_video_div {\n    margin-top: 20px;\n  }\n\n  .adventure_video_div > video {\n    width: 100%;\n    object-fit: fill !important;\n  }\n  \n}\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 450px) {\n\n  .adventure_wrapper {\n    margin-top: 30px;\n  }\n  \n  .adventure_heading {\n    font-size: 30px;\n    line-height: 34px;\n    margin-bottom: 10px;\n  }\n  \n  .adventure_para {\n    max-width: 100%;\n    font-size: 16px;\n    line-height: 20px;\n    padding: 0 20px;\n  }\n  \n  .adventure_btn {\n    font-size: 16px;\n    margin-left: 5px;\n  }\n  \n  .adventure_video_div {\n    margin-top: 20px;\n  }\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
